import React, { useState } from "react";
import styles from "./Category.module.css";
import Item from "./Item";
import * as FaIcons from "react-icons/fa";
import { useSwipeable } from "react-swipeable";

function Category(props) {
  

  const [ItemIndex, setItem] = useState(0);

  const nextItem = () => {
    
    setItem(ItemIndex === props.items.length - 1 ? 0 : ItemIndex + 1);
  };

  const previousItem = () => {
    
    setItem(ItemIndex === 0 ? props.items.length - 1 : ItemIndex - 1);
  };

  const handlers = useSwipeable({
    onSwipedLeft: nextItem,
    onSwipedRight: previousItem,
  });

  return (
    <div className={styles.Category} {...handlers}>
      <div className={styles.title}>{props.title}</div>
      <div className={styles.navigation}>
        <FaIcons.FaArrowAltCircleLeft
          className={styles.Arrow}
          onClick={previousItem}
        />
        <FaIcons.FaArrowAltCircleRight
          className={styles.Arrow}
          onClick={nextItem}
        />
      </div>
      <div className={styles.ItemSelector} >
        {props.items.map((c, i) => (          
          <Item
            key={i}
            Image={c.Image}
            ProductName={c.ProductName}
            Price={c.Price}
            slideIndex={i}
            currentSlide={ItemIndex}
            
          />
        ))}
      </div>

      <span className={styles.dots}>
        {props.items.map((c, i) => (
          <button
            key={`btn` + i}
            onClick={() => setItem(i)}
            className={
              ItemIndex === i
                ? styles.indicator
                : `${styles.indicator} ${styles.indicatorInactive}`
            }
          ></button>
        ))}
      </span>
    </div>
  );
}

export default Category;
